export const menuListCN = {
    'Menu.List.My Analyzes': '我的分析',
    'Menu.List.My.Tools': '工具',
    'Menu.List.Import.Data': '上传数据',

    'Menu.List.Integrate.Data': '启动分析',
    'Menu.List.Integrate.Local.Data': '整合本地数据',
    'Menu.List.Bulk.Local.Data': '整合本地数据',
    'Menu.List.Integrate.SynEcoSys.Data': '整合公共数据(SynEcoSys)',
    'Menu.List.Integrate.Local.SynEcoSys.Data': '整合本地和公共数据(SynEcoSys)',
    'Menu.List.Integrate.Local.SynEcoSys.Data.Br': '整合本地和公共数据(SynEcoSys)',
    'Menu.List.Resource': '资料',
    'Menu.List.TutorialVideos': '教学视频',
    'Menu.List.Documentation': '说明文档',
    'Menu.List.GuideBook': '操作手册',
    'Menu.List.FAQ': 'FAQ',
    'Menu.List.Contact': '联系方式',

    'Menu.List.My.Account': '我的账户',
    'Menu.List.Requested.Downloads': '下载申请',
    'Menu.List.Groups.Setting': '团队管理',
    'Menu.List.Notifications': '通知',
    'Menu.List.Account.Info': '账户信息',

    'Menu.List.Logout': '退出登录',

    'Product.Menu.text1': 'SynEcoSys数据库',
    'Product.Menu.text2': 'CelelensCloud云平台',
    'Product.Menu.text3': '关于我们',
    'Product.Menu.text4': '登出',
    'Product.Menu.text5': '登录',
};

export const menuListUS = {
    'Menu.List.My.Tools': 'Tools',
    'Menu.List.My Analyzes': 'My Analyses',
    'Menu.List.Import.Data': 'Import Data',

    'Menu.List.Integrate.Data': 'Initiate Analysis',
    'Menu.List.Integrate.Local.Data': 'Integrate local data',
    'Menu.List.Bulk.Local.Data': 'Integrate local data',
    'Menu.List.Integrate.SynEcoSys.Data': 'Integrate SynEcoSys data',
    'Menu.List.Integrate.Local.SynEcoSys.Data': 'Integrate local and SynEcoSys data',
    'Menu.List.Integrate.Local.SynEcoSys.Data.Br': 'Integrate local and SynEcoSys data',

    'Menu.List.Resource': 'Resource',
    'Menu.List.TutorialVideos': 'Tutorial Videos',
    'Menu.List.Documentation': 'Documentation',
    'Menu.List.GuideBook': 'GuideBook',
    'Menu.List.FAQ': 'FAQ',
    'Menu.List.Contact': 'Contact',

    'Menu.List.My.Account': 'My account',
    'Menu.List.Requested.Downloads': 'Requested downloads',
    'Menu.List.Groups.Setting': 'Groups setting',
    'Menu.List.Notifications': 'Notifications',
    'Menu.List.Account.Info': 'Account info',

    'Menu.List.Logout': 'Logout',

    'Product.Menu.text1': 'SynEcoSys Database',
    'Product.Menu.text2': 'CeleLens cloud Platform',
    'Product.Menu.text3': 'About us',
    'Product.Menu.text4': 'Sign out',
    'Product.Menu.text5': 'Sign in',
};